export const AppConfig = {
    MAIL_SEND_ACCESS_KEY: process.env.REACT_APP_MAIL_SEND_ACCESS_KEY,
    MAIL_SEND_SECRET_KEY: process.env.REACT_APP_MAIL_SEND_SECRET_KEY
};
